import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordPage } from '@pa/staff'

/** A-02 (Frontend §5.2). */
export const Route = createFileRoute('/forgot-password')({
  component: () => <ForgotPasswordPage siteName="PF Appointments · Super admin" />,
})
